import type { AvailabilitiesPageContent } from '@/lib/types/siteSettings';

export const DEFAULT_AVAILABILITIES_CONTENT: AvailabilitiesPageContent = {
  seo: {
    title: 'Availabilities',
    description:
      'Browse every available unit across Strashin Developments, grouped by address with 501 Alliance highlighted first.',
  },
  heading: {
    eyebrow: 'Availabilities',
    title: 'Current units available',
    description:
      "Explore all available suites across our portfolio. Listings are grouped by address so you can quickly scan what's open at each property.",
  },
  filters: {
    title: 'Filters',
    subtitle: 'Filter by price, size, and use.',
    emptyLabel: 'No active filters',
    activeTemplate: '{count} active',
    resetLabel: 'Reset',
    openLabel: 'Open filters',
    drawerTitle: 'Filter availabilities',
    drawerApplyLabel: 'Apply',
    drawerResetLabel: 'Reset',
    chipPriceLabel: 'Monthly rent',
    chipSizeLabel: 'Size',
    chipUseLabel: 'Use',
  },
  viewToggle: {
    label: 'View',
    cardsLabel: 'Cards',
    mapLabel: 'Map + list',
  },
  filterControls: {
    priceTitle: 'Monthly rent ($)',
    priceDescription: 'Total rent amount monthly',
    sizeTitle: 'Suite size (sq ft)',
    sizeDescription: 'Filter by total rentable area.',
    usesTitle: 'Permitted uses',
    usesDescription: 'Choose one or more building types.',
    minLabel: 'Min',
    maxLabel: 'Max',
    placeholder: 'Any',
  },
  results: {
    noMatchesMessage: 'No available units match these filters.',
    noAvailabilityMessage:
      'No units are available at the moment. Check back soon for new availability.',
    clearFiltersLabel: 'Clear filters',
    errorMessage: "We're unable to load availabilities right now.",
  },
  list: {
    addressEyebrow: 'Address',
    unitCountSingular: '1 unit available',
    unitCountPlural: '{count} units available',
    viewPropertyLabel: 'View property overview',
  },
  mapPanel: {
    backLabel: 'All addresses',
    addressEyebrow: 'Address',
    addressesEyebrow: 'Addresses with availability',
    browseTitle: 'Browse pins',
    browseDescription: 'Tap a pin on the map, or pick an address to preview available suites.',
    selectUnitEyebrow: 'Select a unit',
    selectUnitDescription:
      'Tap a suite above to preview rent, size, and availability before opening the full details page.',
    tapPinEyebrow: 'Tap a pin',
    tapPinDescription: 'Select an address to see every available suite at that location.',
    suiteCountSingular: '1 suite',
    suiteCountPlural: '{count} suites',
    mapPinFallback: 'Map pin coming soon',
  },
  mapUnitRow: {
    unitLabelTemplate: 'Unit {unitLabel}',
    levelLabelTemplate: '{floor}',
    divisibleLabel: 'Divisible',
    incentivesLabel: 'Incentives',
  },
  quickView: {
    eyebrow: 'Preview',
    titleTemplate: 'Unit {unitLabel} · Floor {floor}',
    rentLabel: 'Rent (est.)',
    rentSuffix: '/ mo',
    sizeLabel: 'Size',
    availabilityLabel: 'Availability',
    scheduleLabel: 'Schedule showing',
    detailsLabel: 'See unit details',
    divisibleLabel: 'Divisible',
    incentivesLabel: 'Incentives',
  },
};
